export default __webpack_public_path__ + "static/media/process4-min.73d12cf3.jpg";